module.exports = __webpack_public_path__ + "static/img/mt.485b92ba.svg";